import React from 'react'
import { string, arrayOf, shape, oneOf, oneOfType, array } from 'prop-types'

import styles from './Breadcrumbs.module.scss'
import Type from '../Type'
import classNames from 'classnames'

const Breadcrumbs = ({
  breadcrumbs,
  highlight = 'last',
  size = ['body2', 'body3']
}) => {
  if (!breadcrumbs || !breadcrumbs.length === 0) return null
  return (
    <div
      className={classNames(styles.Breadcrumbs, highlight && styles[highlight])}
    >
      {breadcrumbs.map(
        ({ name }, i) =>
          name && (
            <div className={styles.Crumb} key={`Breadcrumb-${i}`}>
              <Type size={size} weight="medium">
                {name}
              </Type>
            </div>
          )
      )}
    </div>
  )
}

Breadcrumbs.propTypes = {
  highlight: oneOf(['none', 'all-but-first', 'last']),
  breadcrumbs: arrayOf(
    shape({
      name: string
    })
  ).isRequired,
  size: oneOfType([string, array])
}

export default Breadcrumbs
